import React from "react";
import { Info, AlertTriangle, AlertOctagon, ShieldAlert } from "lucide-react";

const VARIANTS = {
    info: { cls: "bg-[#2563EB]/5 border-[#2563EB]/30 text-[#1E3A8A]", Icon: Info },
    attenzione: { cls: "bg-[#F59E0B]/10 border-[#F59E0B]/40 text-[#92400E]", Icon: AlertTriangle },
    alto: { cls: "bg-[#DC2626]/10 border-[#DC2626]/40 text-[#991B1B]", Icon: ShieldAlert },
    critico: { cls: "bg-[#DC2626] border-[#DC2626] text-white", Icon: AlertOctagon },
};

export function AlertBanner({ variant = "info", title, children, className = "", testId }) {
    const v = VARIANTS[variant] || VARIANTS.info;
    const { Icon } = v;
    return (
        <div
            data-testid={testId || `alert-banner-${variant}`}
            className={`flex items-start gap-3 p-4 rounded-lg border ${v.cls} ${className}`}
        >
            <Icon className="w-5 h-5 shrink-0 mt-0.5" strokeWidth={2} />
            <div className="flex-1 text-sm">
                {title && <div className="font-semibold mb-0.5">{title}</div>}
                <div className="opacity-90">{children}</div>
            </div>
        </div>
    );
}

export default AlertBanner;
